import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramIcon, FacebookIcon, MusicIcon, PhoneIcon, MailIcon } from 'lucide-react';
import { CONTACT } from '../data/copy';
import { neighborhoods } from '../data/neighborhoods';
import { useLanguage } from '../contexts/LanguageContext';
import { SectionLink } from './SectionLink';
const socials = [{
  label: 'Instagram',
  Icon: InstagramIcon
}, {
  label: 'Facebook',
  Icon: FacebookIcon
}, {
  label: 'TikTok',
  Icon: MusicIcon
}];
const columnTitle = 'font-display text-sm font-bold uppercase tracking-wider text-white';
const columnLink = 'text-[15px] text-white/65 transition-colors duration-150 ease-out hover:text-rust-light';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="w-full bg-forest-deep" data-id="element-94" data-mp="3qf9qiom24ygb">
      <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8 lg:py-16" data-id="element-95" data-mp="29y5gy0qz9kv0">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-[minmax(0,1.3fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1.1fr)]" data-id="element-96" data-mp="2ey0a6ay86mj8">
          <div data-id="element-97" data-mp="3lalfndz543tf">
            <div className="max-w-xs" data-id="element-98" data-mp="3la29svmrl5vr">
              <span className="flex items-center justify-center" data-id="element-99" data-mp="3gagzxq623d49">
                <img src="https://i.imgur.com/Wx3mHZ2.png" alt="Armando Junk Removal and Hauling logo — junk removal and hauling in San Francisco, CA" className="h-20 w-auto object-contain" data-id="element-100" data-mp="3gca6z6kkzzcs" />
              </span>
              <p className="mt-5 text-center text-[15px] leading-relaxed text-white/65" data-id="element-101" data-mp="81pexhlx8v8u">
                {t.footer.tagline}
              </p>
            </div>
            <div className="mt-6 flex gap-3" data-id="element-102" data-mp="hsk1yo6zryvc">
              {socials.map(({
              label,
              Icon
            }) => <SectionLink key={label} hash="#contact" className="flex h-10 w-10 items-center justify-center rounded-md bg-white/10 text-white transition-colors duration-150 ease-out hover:bg-rust" data-id="element-103" data-mp="cu0hks81qv53">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-104" data-mp="mpts6627gek8" />
                  <span className="sr-only" data-id="element-105" data-mp="twfnps3h9trd">{label}</span>
                </SectionLink>)}
            </div>
          </div>

          <nav aria-label={t.footer.companyTitle} data-id="element-106" data-mp="yrv16ixkpnn9">
            <h2 className={columnTitle} data-id="element-107" data-mp="13s9980z6cxla">{t.footer.companyTitle}</h2>
            <ul className="mt-4 space-y-3" data-id="element-108" data-mp="18jr0tyfb5ltl">
              {t.footer.companyLinks.map(link => <li key={link.href} data-id="element-109" data-mp="1clunzkbcaeup">
                  <SectionLink hash={link.href} className={columnLink} data-id="element-110" data-mp="1ckt02f985xvk">
                    {link.label}
                  </SectionLink>
                </li>)}
            </ul>
          </nav>

          <nav aria-label={t.footer.servicesTitle} data-id="element-111" data-mp="1ml3chxnfr19o">
            <h2 className={columnTitle} data-id="element-112" data-mp="1rilgd9mliqat">{t.footer.servicesTitle}</h2>
            <ul className="mt-4 space-y-3" data-id="element-113" data-mp="1rgshwhm4zcdw">
              {t.footer.serviceLinks.map(label => <li key={label} data-id="element-114" data-mp="3od85lcgo84lz">
                  <SectionLink hash="#services" className={columnLink} data-id="element-115" data-mp="3t9q4vwt8faqx">
                    {label}
                  </SectionLink>
                </li>)}
            </ul>
          </nav>

          <nav aria-label={t.footer.neighborhoodsTitle} data-id="element-116" data-mp="25nvi6qtyjc4v">
            <h2 className={columnTitle} data-id="element-117" data-mp="25mamuyztjp5y">{t.footer.neighborhoodsTitle}</h2>
            <ul className="mt-4 space-y-3" data-id="element-118" data-mp="21nlexlxjuztp">
              {neighborhoods.map(neighborhood => <li key={neighborhood.slug} data-id="element-119" data-mp="1wp0996zj3nxv">
                  <Link to={`/${neighborhood.slug}`} className={columnLink} data-id="element-120" data-mp="2tdzjusnl51t8">
                    {neighborhood.name} Junk Removal
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>

        <div className="mt-12 flex flex-col gap-6 border-t border-white/10 pt-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-121" data-mp="2kc8ghugip72j">
          <div data-id="element-122" data-mp="2fdow3yhko3ca">
            <h2 className={columnTitle} data-id="element-123" data-mp="2fgayzktipuo6">{t.footer.callTitle}</h2>
            <a href={CONTACT.phoneHref} className="mt-3 flex items-center gap-2.5 whitespace-nowrap font-display text-2xl font-black text-rust-light transition-colors duration-150 ease-out hover:text-white" data-id="element-124" data-mp="18yxn17iapc76">
              <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-125" data-mp="2wmfxoqz8ffcw" />
              {CONTACT.phone}
            </a>
            <a href={`mailto:${CONTACT.email}`} className="mt-2 flex items-center gap-2.5 text-[15px] text-white/65 transition-colors duration-150 ease-out hover:text-rust-light" data-id="element-126" data-mp="2ivb86hpkw3ga">
              <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-127" data-mp="3bjgpeuhfbabd" />
              {CONTACT.email}
            </a>
            <p className="mt-2 text-[15px] text-white/65" data-id="element-128" data-mp="3fkacxmqyen3q">{CONTACT.location}</p>
          </div>

          <p className="text-sm text-white/50" data-id="element-129" data-mp="31khjhjo1lss2">{t.footer.copyright}</p>
        </div>
      </div>
    </footer>;
}